<template>
  <div>
    <div class="base-wrap clearfix">
      <div class="base-item">
        <em class="label">申请事由：</em>
        <div class="content">
          {{formData.title }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">收款人：</em>
        <div class="content" v-if="formData.receive_name">
          {{ formData.receive_name || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">开户行：</em>
        <div class="content">
          {{ formData.receive_bank_type || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">收款账号：</em>
        <div class="content">
          {{ formData.receive_bank_no || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">最晚归还：</em>
        <div class="content">
          {{ formData.back_time || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">币种类型：</em>
        <div class="content" v-if="formData.coin_type">
          {{ coins.constMap.idMap[formData.coin_type].name  || '--/--'}}
        </div>
      </div>
      <div class="base-item">
        <em class="label">总金额：</em>
        <div class="content">
          {{formData.format_sum_money}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">附件：</em>
        <div class="content" v-if="formData.img_keys&& formData.img_keys.length>0">
          <template v-for="img in formData.img_keys">
            <a style="color: #2f78ff;" :key='img.key'
              :href="`/api/base/download?key=${img.key}`"
              target="_blank">{{img.name}}&nbsp;&nbsp;</a>&nbsp;
          </template>
        </div>
        <div class="content" v-else>--/--</div>
      </div>
    </div>

  </div>
</template>

<script>
import { coins } from '@/const'
export default {
  name: 'applayReserveFundsDetail', // 报销
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    expenseTypes: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      coins
    }
  },
}
</script>
